import { FC } from "react";
import {
  DatePickerProps,
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { frFR } from "@mui/x-date-pickers/locales";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/fr";

dayjs.extend(updateLocale);

dayjs.updateLocale("fr", {
  months: [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
  ],
  monthsShort: [
    "Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin",
    "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc.",
  ],
});

type Props = {} & DatePickerProps<Dayjs, boolean>;

const DatePicker: FC<Props> = (props) => {
  let sx = { ...props.sx };
  if (typeof props.sx === "function") {
    sx = props.sx;
  }

  return <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="fr" // <-- months, weekdays, parsing/formatting in French
      localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText} // <-- labels like "Cancel", "Clear", etc.
    >
      <MuiDatePicker format="DD/MM/YYYY" {...props} sx={sx} />
    </LocalizationProvider>
  
  
};

export default DatePicker;
